import { useContext, useEffect, useMemo, useState } from "react";
import DBModal from "../../../component/global/DBModal";
import BackButton from "../../../component/global/BackButton";
import { useTranslation } from "react-i18next";
import { ReactComponent as Amazon } from "../../../asset/icons/amazonIcon.svg";
import { ReactComponent as Calender } from "../../../asset/icons/cal.svg";
import { ReactComponent as PercentIcon } from "../../../asset/icons/percentIcon.svg";
import { ReactComponent as UserIcon } from "../../../asset/icons/user-icon.svg";
import { ReactComponent as FeedCoin } from "../../../asset/icons/three-coin-icon.svg";
import { ReactComponent as DownloadFile } from "../../../asset/icons/downloadFileIcon.svg";
import DBButton from "../../../component/global/DBButton";
import { ToastContext } from "../../../component/global/ToastContext";
import { get, post } from "../../../controlers/global/ConfigRequest";
import {
    BUY_DISCOUNT,
    DISCOUNT_LIST_OBJ,
} from "../../../helperData/ApiAddress";
import moment from "moment-jalaali";
import { clubLevels } from "../../../helperData/Data";
import { Spinner } from "react-bootstrap";

function DiscountCardDetailModal(props) {
    const { show, onHide, archive, id } = props;

    const showToast = useContext(ToastContext);
    const [loader, setLoader] = useState(true);
    const [buyLoader, setBuyLoader] = useState(false);
    const [data, setData] = useState();
    const { t } = useTranslation();

    useEffect(() => {
        setLoader(true);
        if (id) {
            get(DISCOUNT_LIST_OBJ.replace(":id", id))
                .then((r) => {
                    setData(r);
                })
                .finally((e) => {
                    setLoader(false);
                });
        }
    }, [id]);

    const buyDiscount = () => {
        setBuyLoader(true);
        post(BUY_DISCOUNT, {
            quantity: 1,
            discount_card: id,
        })
            .then((r) => {
                showToast(
                    t(
                        "Src.pages.UserPages.UserDiscount.DiscountCardDetailModal.Buy.Success"
                    ),
                    "success"
                );
                onHide();
            })
            .finally((e) => {
                setBuyLoader(false);
            });
    };

    const leftTimes = useMemo(() => {
        let leftDays = 0;
        let leftHours = 0;
        let leftMinutes = 0;
        let leftSeconds = 0;
        if (data?.date_end) {
            const endTime = new Date(`${data.date_end}T23:59:59`).getTime();
            const nowTime = new Date().getTime();
            const diffTime = endTime - nowTime;
            const day = 24 * 3600 * 1000;
            const hour = 3600 * 1000;
            const minutes = 60 * 1000;
            const seconds = 1000;
            leftDays = Math.floor(diffTime / day);
            leftHours = Math.floor((diffTime - leftDays * day) / hour);
            leftMinutes = Math.floor(
                (diffTime - (leftDays * day + leftHours * hour)) / minutes
            );
            leftSeconds = Math.floor(
                (diffTime -
                    (leftDays * day +
                        leftHours * hour +
                        leftMinutes * minutes)) /
                    seconds
            );
        }
        return { leftDays, leftHours, leftMinutes, leftSeconds };
    }, [data?.date_end, show]);

    function showContent() {
        if (loader)
            return <Spinner animation="border" style={{ marginTop: 20 }} />;
        return (
            <>
                <div className="discount-card-detail-header">
                    <div className="discount-card-detail-title">
                        <div className="discount-card-detail-logo">
                            <Amazon />
                        </div>
                        <div>
                            {data?.name}{" "}
                            {data?.discount_amount
                                ? "٪" + data?.discount_amount
                                : ""}
                        </div>
                    </div>
                    <div className="discount-card-detail-counter">
                        <div className="discount-card-detail-time">
                            {leftTimes.leftHours}:{leftTimes.leftMinutes}':
                            {leftTimes.leftSeconds}"
                        </div>
                        <div className="discount-card-detail-calender">
                            <div className="discount-card-detail-calender-line-1"></div>
                            <div className="discount-card-detail-calender-line-2"></div>
                            {leftTimes.leftDays}
                        </div>
                    </div>
                </div>
                <div className="discount-card-detail-description">
                    {data?.description}
                </div>
                <div className="discount-card-detail-container">
                    <div>
                        <div className="discount-card-detail-summary discount-card-detail-summary-date">
                            <div className="discount-card-detail-summary-title">
                                {t(
                                    "Src.pages.UserPages.UserDiscount.DiscountCardDetailModal.Timespan"
                                )}
                            </div>
                            <Calender />
                            <div className="discount-card-detail-summary-detail">
                                {moment(data?.date_start).format(
                                    "jYYYY/jMM/jDD"
                                )}
                                <span>~</span>{" "}
                                {moment(data?.date_end).format("jYYYY/jMM/jDD")}
                            </div>
                        </div>
                        <div className="discount-card-detail-summary">
                            <div className="discount-card-detail-summary-title">
                                {t(
                                    "Src.pages.UserPages.UserDiscount.DiscountCardDetailModal.NumberCard"
                                )}
                            </div>
                            <PercentIcon />
                            <div className="discount-card-detail-summary-detail">
                                {data?.remain_count}{" "}
                                {t(
                                    "Src.pages.UserPages.UserDiscount.DiscountCardDetailModal.Number"
                                )}
                            </div>
                        </div>
                    </div>
                    {!archive ? (
                        <div className="discount-card-detail-payment">
                            <button
                                className="discount-card-detail-download-btn"
                                onClick={() => window.print()}
                            >
                                <DownloadFile />
                            </button>
                            <DBButton
                                className="discount-card-detail-btn"
                                caption={t(
                                    "Src.pages.UserPages.UserDiscount.DiscountCardDetailModal.Btn"
                                )}
                                loading={buyLoader}
                                onClick={buyDiscount}
                            />
                        </div>
                    ) : null}
                </div>
                <div className="discount-card-detail-users">
                    {data?.requireds.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className="discount-card-detail-users-item"
                            >
                                <div className="discount-card-detail-users-item-title">
                                    {item?.target_company?.logo ? (
                                        <img
                                            src={item.target_company.logo}
                                            alt={
                                                item?.target_company?.name || ""
                                            }
                                        />
                                    ) : null}
                                    <div>{item?.target_company?.name}</div>
                                </div>
                                <div className="discount-card-detail-users-item-type">
                                    <UserIcon />
                                    <div>
                                        {clubLevels.find(
                                            (el) => el.id === item.club_level
                                        )?.title || ""}
                                    </div>
                                </div>
                                <div className="discount-card-detail-users-item-feedCoin">
                                    <FeedCoin />
                                    <div>{item.required_score}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </>
        );
    }

    return (
        <div>
            <DBModal
                minWidth={300}
                show={show}
                onHide={onHide}
                className="discount-user-discount-card-detail-modal"
            >
                <DBModal.Content>
                    <div className="header-modal">
                        <div className="logo">
                            <span>
                                {t(
                                    "Src.pages.UserPages.UserDiscount.DiscountCardDetailModal.Title"
                                )}
                            </span>
                        </div>
                        <BackButton onclickFunction={onHide} />
                    </div>
                    <div className="content-modal">{showContent()}</div>
                </DBModal.Content>
            </DBModal>
        </div>
    );
}

export default DiscountCardDetailModal;
